import { apiRequestBase } from "./client";
import { env } from "../config/env";

export const authorizationApi = {
  getBusinessProfilesByEmail: (email: string) =>
    apiRequestBase(`${env.authApiBase}`, `/User/GetBusinessProfilesByMail?email=${encodeURIComponent(email)}`),
};
